import axios from './_axios_config';
import { request, buildQuery } from './_process_request';

export const ct_reports = {
    // params: { year, month, day } (Resumo geral)
    async getDashboard(params) {
        return request(axios.get(`/dashboard${buildQuery(params)}`));
    },

    async getReports(params) {
        return request(axios.get(`/reports${buildQuery(params)}`));
    },

    async getBalance() {
        return request(axios.get('/balance'));
    },

    async setOpeningBalance(data) {
        return request(axios.post('/balance/opening', data));
    },

    async getOpeningHistory() {
        return request(axios.get('/balance/opening/history'));
    },
};
